
(() => {
  const formatMoney = (cents, format) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
    }).format((Number(cents) || 0) / 100);
  };

  document.querySelectorAll('[data-np-portrait]').forEach((root) => {
    if (root.dataset.npInitialized === 'true') return;
    root.dataset.npInitialized = 'true';

    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const form = root.querySelector('.np-portrait__form');
    if (!form) return;

    const variantIdInput = root.querySelector('[data-np-variant-id]');
    const priceEl = root.querySelector('[data-np-price]');
    const compareEl = root.querySelector('[data-np-compare]');
    const ctaPrice = root.querySelector('[data-np-cta-price]');
    const submit = root.querySelector('[data-np-submit]');
    const errorBox = root.querySelector('[data-np-error]');
    const addonChecks = Array.from(root.querySelectorAll('[data-np-addon]'));

    let basePrice = Number(root.querySelector('[data-np-variant-radio]:checked')?.dataset.price || 0);

    const addonTotal = () =>
      addonChecks
        .filter((el) => el.checked)
        .reduce((sum, el) => sum + Number(el.dataset.price || 0), 0);

    const updateCtaTotal = () => {
      if (ctaPrice) ctaPrice.textContent = formatMoney(basePrice + addonTotal(), moneyFormat);
    };

    root.querySelectorAll('[data-np-variant-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;

        variantIdInput.value = radio.value;
        basePrice = Number(radio.dataset.price || 0);

        if (priceEl) priceEl.textContent = formatMoney(basePrice, moneyFormat);

        const compare = Number(radio.dataset.compare || 0);
        if (compareEl) {
          if (compare > basePrice) {
            compareEl.textContent = formatMoney(compare, moneyFormat);
            compareEl.classList.remove('is-hidden');
          } else {
            compareEl.textContent = '';
            compareEl.classList.add('is-hidden');
          }
        }

        if (submit) submit.disabled = radio.dataset.available !== 'true';
        updateCtaTotal();

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url);
        } catch (e) {}
      });
    });

    addonChecks.forEach((check) => check.addEventListener('change', updateCtaTotal));

    root.querySelectorAll('[data-np-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const main = root.querySelector('.np-portrait__main-image');
        if (main && thumb.dataset.image) {
          main.src = thumb.dataset.image;
          main.removeAttribute('srcset');
        }
        root.querySelectorAll('[data-np-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submit?.disabled) return;

      if (errorBox) {
        errorBox.hidden = true;
        errorBox.textContent = '';
      }

      submit?.setAttribute('aria-busy', 'true');
      if (submit) submit.disabled = true;

      try {
        const formData = new FormData(form);
        const properties = {};

        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[') && value) {
            const propertyName = key.slice(11, -1);
            properties[propertyName] = value;
          }
        }

        const mainVariantId = Number(formData.get('id'));
        const items = [{
          id: mainVariantId,
          quantity: 1,
          properties
        }];

        addonChecks
          .filter((el) => el.checked)
          .forEach((el) => {
            items.push({
              id: Number(el.dataset.variantId),
              quantity: 1,
              properties: {
                '_NP add-on for': String(mainVariantId),
                '_Use same portrait artwork': 'Yes'
              }
            });
          });

        const response = await fetch(window.Shopify?.routes?.root + 'cart/add.js' || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item to cart.');

        if (root.dataset.cartBehavior === 'stay') {
          submit?.removeAttribute('aria-busy');
          if (submit) submit.disabled = false;
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        } else {
          window.location.href = window.Shopify?.routes?.cart_url || '/cart';
        }
      } catch (error) {
        if (errorBox) {
          errorBox.textContent = error.message || 'Something went wrong. Please try again.';
          errorBox.hidden = false;
        }
        submit?.removeAttribute('aria-busy');
        if (submit) submit.disabled = false;
      }
    });

    updateCtaTotal();
  });
})();
